module.exports = __webpack_public_path__ + "img/Melder.c954bd6c.svg";